import { useRef, useEffect } from 'react';

function useFocusOnError(isErrorAppears) {
  const focusingRef = useRef();

  useEffect(() => {
    if (isErrorAppears) {
      focusingRef.current.scrollIntoView();
    }
  }, [isErrorAppears]);

  return focusingRef;
}

export default useFocusOnError;
